import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import DashboardNav from "./components/navbar/Navbar";
import AppFooter from "../../components/app-footer/AppFooter";
import ContactDialog from "./components/contact-dialog/ContactDialog";
import Personas from "../personas/Personas";
import Empresas from "../empresas/Empresas";
import Automotores from "../automotores/Automotores";
import Telefonos from "../telefonos/Telefonos";
import Log from "../log/Log";
import FAQ from "../faq/Faq";
import Perfil from "../me/Perfil";

import UiUtils from "../../utils/UiUtils";
import ApiClient from "../../utils/ApiClient";
import Session from "../../utils/Session";
import agilDataLogo from "../../images/logo-app.svg";
import emptyLogo from "../../images/logo-empty.svg";
import lstrings from "../../utils/LStrings";
import CompleteUserData from "../home/components/complete-user-data/CompleteUserData";
import TabScoreCrediticioBatch from "../score-crediticio-batch/TabScoreCrediticioBatch";
import AdminRoute from "../../components/AdminRoute";
import TabAsociados from "../asociados/TabAsociados";



class Dashboard extends React.Component {
    constructor() {
        super();
        this.state = {
            showingContactDialog: false,
            logo: "",
            mostrarCompleteUserData: false,
			user: {},
			isAdmin: false
        };
    }

    componentDidMount() {
        this.loadLogo();
		this.loadCompleteUserForm();
		this.setState({isAdmin:Session.getUser().isAdmin})
    }

    loadCompleteUserForm = () => {
        ApiClient.getCurrentUser().then((resp) => {
            if (resp.data == null) {
                Session.clear();
                location.reload();
            } else if (resp.data.incompleto) {
                this.setState({
                    user: resp.data,
                });
                this.setState({
                    mostrarCompleteUserData: true,
                });
            }
        });
    };

    cancelarCompleteUserData = () => {
        this.setState({
            mostrarCompleteUserData: false,
        });
        Session.clear();
        location.reload();
    };
    cerrarCompleteUserData = () => {
        this.setState({
            mostrarCompleteUserData: false,
        });
    };

    loadLogo = () => {
        if (Session.isMainSite()) {
            this.setState({
                logo: agilDataLogo,
			});

			document.title = lstrings.titleAgd;
            return;
        }

        UiUtils.showProgress(true);
        ApiClient.getAccount()
            .then(function (res) {
                if (res.result.code === 200) {
                    Session.setAccount(res.data);
                    document.title = Session.getCompanyName();
                    return ApiClient.getClientLogo(res.data.idCliente);
                } else {
                    throw UiUtils.handledError(res.result.info);
                }
            })
            .then(this.onFinishGetLogo)
            .then(function (res) {
                if (res) {
                    let account = Session.getAccount();
                    account.email = res.email;
                    Session.setAccount(account);
                    UiUtils.showProgress(false);
                }
            })
            //.catch(this.catchError)
            .catch((error) => {
                if (error.status == 404) {
                    // ESTO ES HORRIBLE
                    // TODO: controlar mejor
                    const logo = emptyLogo;
                    this.setState({
                        logo: logo,
                    });
                    ApiClient.getClient(Session.getAccount().idCliente).then(
                        function (res) {
                            if (res) {
                                let account = Session.getAccount();
                                account.email = res.email;
                                Session.setAccount(account);
                                UiUtils.showProgress(false);
                            }
                        }
                    );
                } else {
                    UiUtils.showError(error);
                }
            });
    };

    onFinishGetLogo = (res) => {
        if (res) {
            const logo = Session.getLogo();
            this.setState({
                logo: logo,
            });
            return ApiClient.getClient(Session.getAccount().idCliente);
        }
    };

    onShowContactDialog = () => {
        this.setState({
            showingContactDialog: true,
        });
    };

    onCloseContactDialog = () => {
        this.setState({
            showingContactDialog: false,
        });
    };

    render() {
        let match = {
            path: "/dashboard",
            url: "/dashboard",
            isExact: false,
            params: {},
        };

        return (
            <div>
                <div className="wrapper">
                    <DashboardNav
                        onShowContactDialog={this.onShowContactDialog}
                        logo={this.state.logo}
                    />
                    <ContactDialog
                        show={this.state.showingContactDialog}
                        onClose={this.onCloseContactDialog}
                    />
                    <CompleteUserData
                        data={this.state.user}
                        mostrarCompleteUserData={
                            this.state.mostrarCompleteUserData
                        }
                        onCerrarCompleteUserData={this.cerrarCompleteUserData}
                        onCancelarCompleteUserData={
                            this.cancelarCompleteUserData
                        }
                    />
                    <div className="container-fluid">
                        <Route
                            path={`${match.url}/personas`}
                            component={Personas}
                        />
                        <Route
                            path={`${match.url}/empresas`}
                            component={Empresas}
						/>
						{process.env.REACT_APP_FLAVOR !== "reseller" &&
							<Route
								path={`${match.url}/automotores`}
								component={Automotores}
							/>
						}
                        <Route
                            path={`${match.url}/telefonos`}
                            component={Telefonos}
                        />

                        <AdminRoute
                            isAdmin={this.state.isAdmin && !Session.getUser().isDisa}
                            path={`${match.url}/score-batch`}
                            component={TabScoreCrediticioBatch}
                        />
                        
                        <AdminRoute
							isAdmin={Session.getUser().isDisaAdmin || Session.getUser().isSuperadmin || process.env.REACT_APP_FLAVOR !== "reseller"}
                            path={`${match.url}/asociados`}
                            component={TabAsociados}
                        />

                        <Route
                            path={`${match.url}/faq`}
                            component={FAQ}
                        />
                        <Route
                            path={`${match.url}/me`}
                            component={Perfil}
                        />
                        <Route
                            path={`${match.url}/log`}
                            component={Log}
                        />
                    </div>
                </div>
                <div className="clearfix" />
                <AppFooter />
            </div>
        );
    }
}

Dashboard.propTypes = {
    match: PropTypes.object,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/Dashboard.js